<template>
    <li class="dropdown">
        <a href="#" data-target="#" class="dropdown-toggle pmlFormatCurrencyByIdwaves-light" data-toggle="dropdown" aria-expanded="true">
            <i class="fa fa-bell"></i> <span class="badge badge-xs badge-danger" v-if="unreadNotifications">{{ unreadNotifications }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg notification_list">
            <li class="notifi-title">
                <span class="btn btn-primary btn-xs pull-right" @click.prevent="markAllAsRead()" v-pml-tooltip.left="$t('mark_all_as_read')"><i class="md md-visibility"></i></span>
                <span class="t_uppercase">{{ $t('notifications') }}</span>
            </li>
            <li class="list-group notification-list" v-for="(item, index) in list" :key="item.id" :class="{ 'unread': item.seen_at === null }">
                <a href="#" class="list-group-item" :class="item.type" @click.prevent="notificationClick(item)">
                    <div class="media">
                        <div class="pull-left p-t-10 p-r-10">
                            <em class="fa fa-bell-o fa-2x"></em>
                        </div>
                        <div class="media-body">
                            <p class="m-0" v-html="item.message"></p>
                            <small class="show">{{ item.created_at | pmlHumanDate }}</small>
                        </div>
                    </div>
                </a>
            </li>
            <li class="list-group nicescroll notification-list" v-if="!list.length">
                <a href="#" class="list-group-item">
                    <div class="media">
                        <div class="media-body m-0">
                            <p class="m-0 t_center">
                                <small><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</small>
                            </p>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </li>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { orderBy, isNil, forEach } from 'lodash'
    import { markAsRead } from 'services/notifications'

    export default {
        computed: {
            ...mapGetters({
                member: 'getMember',
                notifications: 'getNotifications',
                unreadNot: 'getUnreadNotifications'
            }),
            list () {
                return orderBy(this.notifications, 'created_at', 'desc')
            },
            unreadNotifications () {
                return this.unreadNot.length
            }
        },
        mounted () {
            window.Echo.channel(`PumpMyLead.Member.${this.member.id}`)
                .listen('.PumpMyLead\\Events\\NotificationCreated', (data) => {
                    this.saveNotification(data.notification)
                    this.spawnNotification(
                        'Pump My Lead',
                        '/static/images/logo-notification.png',
                        this.$options.filters.pmlStripTag(data.notification.message)
                    )
                })
        },
        methods: {
            ...mapActions([ 'saveNotification' ]),
            spawnNotification (theBody, theIcon, theTitle) {
                if ('Notification' in window && window.Notification.permission === 'granted') {
                    let options = {
                        body: theBody,
                        icon: theIcon,
                        lang: window.localStorage.getItem('pml_lang')
                    }
                    try {
                        let n = new window.Notification(theTitle, options)

                        n.onclick = () => {
                            window.focus()
                            n.close()
                        }
                    } catch (e) {
                        if (e.name === 'TypeError')
                            return false
                    }
                } else if ('Notification' in window && window.Notification.permission === 'default') {
                    window.Notification.requestPermission(() => {
                        this.spawnNotification(theBody, theIcon, theTitle)
                    })
                }
            },
            notificationClick (notification) {
                if (isNil(notification.seen_at))
                    markAsRead(notification.id)
                        .then(() => {
                            if (!isNil(notification.url))
                                this.openLink(notification.url)
                        })
                else if (!isNil(notification.url))
                    this.openLink(notification.url)
            },
            openLink (link) {
                if (link.indexOf(process.env.URL_LOCAL) >= 0) {
                    this.$router.push({ name: 'dashboard.index' })
                    this.$router.push(link.replace(process.env.URL_LOCAL, ''))
                } else {
                    window.open(link, '_blank')
                }
            },
            markAsRead (notification) {
                markAsRead(notification.id)
            },
            markAllAsRead () {
                forEach(this.unreadNot, (obj) => this.markAsRead(obj))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/root/header/Notifications.vue